import React from 'react'
import Reflux from 'reflux'
import i18 from '../../../i18'
import api from '../../../source/api'
import {Link} from "react-router-dom";
import DownloadFile from "../../common/DownloadFile";

class Download extends Reflux.Component {

    constructor(props) {
        super(props)
        this.state = {
            config: props.config,
            invoices: props.invoices,
            files: [],
            insufficientCredit: false,
        }
    }

    componentDidMount = () => {
        api.post('customer/' + this.state.config.company_id + '/generate', {invoices: this.state.invoices})
            .then((response) => {
                this.setState({files: response.data.files})
            })
            .catch((error) => {
                if (error.response && error.response.status === 422) {
                    if (error.response.data.message === 'NOT_ENOUGH_BALANCE') {
                        this.setState({insufficientCredit: true});
                        return;
                    }
                    this.props.notifyError(error.response.data.message)
                    return;
                }

                this.props.notifyError('Hiba történt a feldolgozás során. (#1001)');
            })
    }

    render() {
        return (
            <section id='customer-assignment'>
                <div className='col-12'>
                    <br/>
                    <br/>
                    <h4>{i18.COMMON._processedSuccessfully}</h4>
                    <br/>
                    {this.state.insufficientCredit
                        ? <div className='text-center'>
                            <h1>Önnek nincs elegendő egyenlege a kimeneti fájlok letöltéséhez. <br/> Kérjük töltse fel egyenlegét.</h1>
                            <div className='text-center margin-top-30'>
                                <Link to='/payment-start' className='green-btn uppercase'>Egyenleg feltöltése</Link>
                            </div>
                        </div>
                        : <div className='text-center'>
                            {this.state.files.map((file) => {
                                return <DownloadFile
                                    title={file.title}
                                    name={file.name}
                                    url={'customer/' + this.state.config.company_id + '/download'}
                                />
                            })}
                        </div>
                    }
                    <div className='text-center'>
                        <br/>
                        <br/>
                        <Link to="/">Új feldolgozás indítása</Link>
                    </div>
                    <br/>
                    <br/>
                </div>
            </section>
        )
    }
}

export default Download


// WEBPACK FOOTER //
// ./src/components/customer/Steps/Download.js